import { render } from "./WithdrawConfirm.vue?vue&type=template&id=6f31ab14"
import script from "./WithdrawConfirm.vue?vue&type=script&lang=js"
export * from "./WithdrawConfirm.vue?vue&type=script&lang=js"

import "./WithdrawConfirm.vue?vue&type=style&index=0&id=6f31ab14&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__